import { Flex } from 'shared/ui/flex';
import { SelectValue } from 'shared/ui/select/selectValue';
import {
	Container,
	DateContainer,
	InputDateContainer,
	InputTimeContainer,
	Wrapper,
} from './styles';
import {
	SelectCalendarProvider,
	SelectControl,
	SelectDateValue,
	SelectMenu,
} from 'shared/ui/select/selectCalendar';
import { LabelText } from 'shared/ui/label';
import { SelectDate } from 'shared/ui/select/selectCalendar/selectDate';
import { useBookingDateTime } from '../lib/useBookingDateTime';
import { SelectTimeIncrement } from 'shared/ui/select/selectTimeIncrement';
import { SelectIncrement } from 'shared/ui/select/selectIncrement';
import { useOrderOptions } from '../lib/useOrderOptions';
import { useAppSelector } from 'shared/lib/store';
import { selectOrderForBooking } from 'entities/orders';
import { useEffect, useRef } from 'react';
import { useBookingDuration } from '../lib/useBookingDuration';
import { generateDurationObjects } from 'shared/lib/time/timeHelper';
import { selectSettings } from 'entities/settings/model/selector';

export const BookingDateTime = () => {
	const guestsOptions = Array(999).fill(true).map((_, index) => ({ value: (index + 1).toString(), label: (index + 1).toString() }));
	const order = useAppSelector(selectOrderForBooking);
	const prohibitUseSelect = useRef(
		order?.status === 'visit_started' ? true : false,
	);

	const appSettings = useAppSelector(selectSettings);

	const durationObjects = generateDurationObjects(appSettings?.min_duration || '01:00', appSettings?.max_duration || '12:00', appSettings?.duration_step || 15);

	const { durationOption, setDurationByTime, setDurationOption } = useBookingDuration();

	const {
		setGuests,
		setTime,
		setSlotDate,
		setDate,
		timesOptions,
		timeslotDate,
		activeBookingTime,
	} = useBookingDateTime(durationOption, setDurationByTime);

	const { dateOption, timeOption, guestsOption } =
		useOrderOptions(timeslotDate, setDate, setDurationOption, setDurationByTime, activeBookingTime);

    
    useEffect(()=>{
      if (timeOption) {
        setDurationByTime(timeOption.value)
      }
      // eslint-disable-next-line
    }, [timeslotDate])

	return (
		<Wrapper>
			<DateContainer>
				<Flex $gap="6px" $justify="space-between">
					<InputDateContainer id="date-select-input">
						<LabelText htmlFor="date-select">Дата</LabelText>
						<SelectCalendarProvider
							setDate={setSlotDate}
							date={dateOption}
							prohibitOpening={prohibitUseSelect.current}
						>
							<SelectDate
								customMenu={SelectMenu}
								customValue={SelectDateValue}
								customControl={SelectControl}
								isDisabled={prohibitUseSelect.current}
							/>
						</SelectCalendarProvider>
					</InputDateContainer>

					<InputTimeContainer id="time-select-input">
						<LabelText htmlFor="time-select">Время</LabelText>
						<SelectValue
							options={timesOptions}
							onChange={setTime}
							defaultValue={timeOption}
							prohibitOpening={prohibitUseSelect.current}
						/>
					</InputTimeContainer>
				</Flex>
			</DateContainer>

			<Flex $gap="6px" $justify="space-between">
				<Container>
					<LabelText htmlFor="guest-select">
						Количество гостей
					</LabelText>
					<SelectIncrement
						options={guestsOptions}
						onChangeOption={setGuests}
						defaultValue={guestsOption}
					/>
				</Container>

				<Container>
					<LabelText htmlFor="duration-select">
						Длительность
					</LabelText>
					{durationOption && (
						<SelectTimeIncrement
							options={durationObjects}
							interval={appSettings?.duration_step || 15}
							onChangeOption={setDurationOption}
							value={durationOption}
						/>
					)}
				</Container>
			</Flex>
		</Wrapper>
	);
};
